<template>
  <div class="head-search">
    <b-input-group-append size="sm" class="mx-2">
      <b-form-input
        size="lg"
        class="mr-sm-4 height"
        placeholder="Search any keyword"
        v-model="searchQuery"
      ></b-form-input>
      <b-img
        v-if="searchQuery == ''"
        :src="`search.png`"
        class="image-size"
      ></b-img>
      <b-img
        v-if="searchQuery != ''"
        :src="`search_cross.png`"
        @click="searchQuery = ''"
        class="image-size"
      ></b-img>
      <b-img :src="`search_mic.png`" class="image-size-mic"></b-img>
    </b-input-group-append>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: "",
    };
  },
  methods: {},
};
</script>

<style scoped>
.head-search {
  position: relative;
}
.height {
  border-radius: 8px;
  padding-left: 40px;
  padding-right: 40px;
}

.image-size {
  height: 16px;
  width: 16px;
  margin-top: 9px;
  cursor: pointer;
  position: absolute;
  left: 20px;
  top:5px
}
.image-size-mic {
  height: 16px;
  width: 16px;
  margin-top: 9px;
  cursor: pointer;
  position: absolute;
  right: 52px;
  top:5px
}
</style>
